import useGetHasAcknowledgedByActivityKey from './druid/providers/ActivityAcknowledgement/useGetHasAcknowledgedByActivityKey';

export default useGetHasAcknowledgedByActivityKey;
